// The installed app's icon badge (docs/PARITY.md P249) — the Mac dock tile's rule
// (`MacAttentionService`: mentions as a number, else "•" for anything unread, else nothing) through the
// Badging API: `navigator.setAppBadge(n)` draws the number, `setAppBadge()` the platform's dot.
export type AppBadge = { kind: 'count'; count: number } | { kind: 'dot' } | { kind: 'clear' };

export function appBadge(mentions: number, unread: boolean): AppBadge {
  if (mentions > 0) return { kind: 'count', count: mentions };
  return unread ? { kind: 'dot' } : { kind: 'clear' };
}
